/* eslint-disable no-throw-literal */
/* eslint-disable no-undefined */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable max-lines-per-function */
import moment from "moment";
import { FormAnswerData } from "types/gql-types";
import { FormValue, FormValues, Status } from "./type";
import { keyFromIdentity } from "./components/helpers";

// eslint-disable-next-line consistent-return
const load = (answer: FormAnswerData): FormValue | FormValues => {
  switch (answer.__typename) {
    case "FormAnswerBoolean":
      return answer.data.boolean ? "true" : "false";

    case "FormAnswerPhoneNumber":
      return { number: answer.data.raw, type: answer.data.phoneType };

    case "FormAnswerSelect":
      return answer.data.selected;

    case "FormAnswerText":
      return answer.data.text;

    case "FormAnswerEmail":
      return answer.data.email ?? "";

    case "FormAnswerDate":
      return moment(answer.data.date).toDate();

    case "FormAnswerUsState":
      return answer.data.state;

    case "FormAnswerAddress": {
      const { address1, address2, city, state, zip } = answer.data;
      return { address1, address2, city, state, zip };
    }

    case "FormAnswerArray":
      return answer.data.keys;

    case "FormAnswerMultiple":
      return answer.data.selections;

    case "FormAnswerDateRange": {
      const { startDate, endDate, current } = answer.data;
      let begin: any = "";
      let end: any = "";

      if (startDate) begin = new Date(startDate);
      if (endDate) end = new Date(endDate);

      return {
        begin,
        end,
        current,
      };
    }

    case "FormAnswerFaxNumber":
      return answer.data.raw;

    case "FormAnswerHouseholdMember":
      return answer.data.householdMember;

    case "FormAnswerMoney":
      return Number(answer.data.amount.substr(1));

    case "FormAnswerUpload":
      return answer.documents.map((document) => ({
        id: document.documentId,
        name: document.documentName,
        status: Status.Finished,
      }));

    default:
      // @ts-ignore
      throw `Unknown answer type ${answer.__typename}`;
  }
};

// unmarshal transforms answer data from the server into an object that is
// suitable to be used as Formik's state value.
export const unmarshal = (data: FormAnswerData[]): FormValues => {
  const nestedByKey: Record<string, FormValues> = data.filter(({ key }) => key)
    .reduce((memo, answer) => {
      const key = keyFromIdentity(answer.identity);
      const value = load(answer);

      // @ts-ignore
      if (memo[answer.key!]) {
        return {
          ...memo,
          [answer.key!]: {
            // @ts-ignore
            ...memo[answer.key!],
            [key]: value,
          },
        };
      }

      return {
        ...memo,
        [answer.key!]: {
          uniqueID: answer.key,
          [key]: value,
        },
      };
    }, {});

  return data.filter(({ key }) => !key).reduce((memo, answer) => {
    const value = load(answer);
    const key = keyFromIdentity(answer.identity);

    if (answer.__typename === "FormAnswerArray") {
      const values = (value as Array<string>)
        .filter(Boolean)
        .map(val => nestedByKey[val])
        .filter(Boolean);

      return { ...memo, [key]: values };
    }

    return { ...memo, [key]: value };
  }, {});
};
